import type { DependencyList } from "react";
import { useCallback } from "react";
import ReactDOM from "react-dom";

// Workaround for https://github.com/facebook/react/issues/19385
// Necessary for event handlers that change focus and change react component state at the same time.
export const useFlushSyncCallback = <T extends any[]>(handler: ((...args: T) => void) | undefined, deps: DependencyList) => {
  return useCallback((...args: T) => {
    (ReactDOM as any).flushSync(() => {
      handler && handler(...args);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
